import { render, staticRenderFns } from "./DistributionRulesModal.vue?vue&type=template&id=cb6efa38&"
import script from "./DistributionRulesModal.vue?vue&type=script&lang=ts&"
export * from "./DistributionRulesModal.vue?vue&type=script&lang=ts&"
import style0 from "./DistributionRulesModal.vue?vue&type=style&index=0&id=cb6efa38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports